import { IMaterialDTO } from '@/types/material';
import { StringUtil } from './StringUtil';

export class Material {
    readonly TextWhenMissing: string = '[MISSING!]';

    private dto: IMaterialDTO

    constructor(dto: IMaterialDTO) {
        this.dto = dto
    }

    shortText(language: string): string {
        let text = this.dto.shortTexts[language]?.text
        if (StringUtil.hasContent(text)) return text as string

        text = this.dto.shortTexts['E']?.text
        if (StringUtil.hasContent(text)) return `[${text}]`

        text = this.dto.shortTexts['K']?.text
        if (StringUtil.hasContent(text)) return `[${text}]`

        return this.TextWhenMissing
    }

    salesText(language: string): string {
        let text = this.dto.salesTexts[language]?.text
        if (StringUtil.hasContent(text)) return text as string

        text = this.dto.salesTexts['E']?.text
        if (StringUtil.hasContent(text)) return `[${text}]`

        text = this.dto.salesTexts['K']?.text
        if (StringUtil.hasContent(text)) return `[${text}]`

        return this.TextWhenMissing
    }
}